import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {Col, Row, UiBox, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {PAGE_URLS} from '~/constants';
import {PRODUCT_SKUS, WEIGHT_LOSS_KEYS, WEIGHT_LOSS_ONE_QUESTIONNAIRES} from '~/constants/medical-questionnaires';
import {setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {submitOrLogMdq} from '~/redux/questionnaires/thunk';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import novofinePlus from '~/assets/images/novofineplus.png';

interface Props {}

const Questionnaire11SaxendaScreen = ({}: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const history = useHistory();
  const mdq = useSelector((state: RootState) => state.questionnaires);
  const {methodKey, medicalUUID, answerOrder} = mdq;
  //   const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  //   const {wpAuthUser} = medicalQuestionnaire;

  //   const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = WEIGHT_LOSS_ONE_QUESTIONNAIRES.find(i => i.key === WEIGHT_LOSS_KEYS.DO_YOU_NEED_NEEDLES);

  const collectedData = mdq.collectedData;

  const selectedPackage = collectedData[WEIGHT_LOSS_KEYS.PACKAGE_SELECTION] || {};
  const selectedProducts = selectedPackage?.data?.productSkus || [];

  const onNextAddProduct = () => {
    onClickSubmit(true);
  };

  const onClickSubmit = (addNeedle?: boolean) => {
    const answerData = {
      key: WEIGHT_LOSS_KEYS.DO_YOU_NEED_NEEDLES,
      index: questionnaire?.index || '',
      data: {},
      order: answerOrder + 1,
    };

    const newSelectedProducts = addNeedle
      ? [...selectedProducts, PRODUCT_SKUS.NOVOFINE_NEEDLES]
      : selectedProducts?.filter((i: any) => i !== PRODUCT_SKUS.NOVOFINE_NEEDLES);

    const newSelectedPackage = {
      key: WEIGHT_LOSS_KEYS.PACKAGE_SELECTION,
      index: questionnaire?.index || '',
      data: {
        productSkus: newSelectedProducts,
      },
      order: answerOrder + 2,
    };

    dispatch(setQuestionnaireAnswer(answerData));
    dispatch(setQuestionnaireAnswer(newSelectedPackage));

    dispatch(
      submitOrLogMdq({
        data: {
          uid: medicalUUID,
          methodKey: methodKey.toLowerCase(),
          status: 'draft',
          data: {
            ...collectedData,
            [WEIGHT_LOSS_KEYS.DO_YOU_NEED_NEEDLES]: answerData,
            [WEIGHT_LOSS_KEYS.PACKAGE_SELECTION]: newSelectedPackage,
          },
        },
      }),
    );
    // dispatch(setNextQuestionnaire({value: WEIGHT_LOSS_KEYS.APPOINTMENT_PREFERENCES}));
    history.push(PAGE_URLS.MDQ1_WHATS_NEXT_SAXENDA);
  };

  return (
    <UiQuestionnaireLayout
      actions={questionnaire?.actions}
      checkoutStep={questionnaire?.checkoutStep}
      handleOnNext={onClickSubmit}
      pageTitle={questionnaire?.title}
      addProductOnNext={onNextAddProduct}
    >
      <Col alignItems="center" textAlign="center" mt={12} px={2}>
        <UiText fontSize="xl" fontWeight="bold" mb={4}>
          {questionnaire?.questions?.default}
        </UiText>
        <UiBox mb={4}>
          <img src={novofinePlus} alt="Saxenda" style={{width: '6.75rem', height: '7.5rem', objectFit: 'contain'}} />
        </UiBox>
        {questionnaire?.descriptions?.default?.map((item, index) => {
          return (
            <UiText key={index} fontSize="sm" mt={4}>
              {item}
            </UiText>
          );
        })}
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire11SaxendaScreen;
